import { navigate } from "gatsby";
import React from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


let responsiveproductlistmobile1 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  let responsiveproductlistmobile2 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };
  let responsiveproductlistmobile3 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
const Layout_1 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgx-0 img-slider" >
            {
                item.length>0?(
                    <Carousel key="img-layout-1"
                        responsive={responsiveproductlistmobile1}
                        >
                        {
                            item.map((_item,i)=>{
                                return <div  key={i} className="">
                                        <img onClick={()=>handleClick(_item.link)} src={_item.images} alt={_item.name} style={{width: '100%', height:128}}/>
                                </div>
                            })
                        }
                    
                    </Carousel>
                ):(null)
            }
       
        </div>
    )
}
const Layout_2 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgx-0 img-slider" >{
            item.length>0?(
                <Carousel key="img-layout-2"
                    responsive={responsiveproductlistmobile2}
                    >
                    {
                        item.map((_item,i)=>{
                            return <div  key={i} className="">
                                    <img onClick={()=>handleClick(_item.link)} src={_item.images} alt={_item.name} style={{width: '100%',height:189}}/>
                            </div>
                        })
                    }
                
                </Carousel>
            ):(null)
        }</div>
        
    )
}

const Layout_3 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/mobile/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgx-0 img-slider" >{
            item.length>0?(
                <Carousel key="img-layout-2"
                    responsive={responsiveproductlistmobile3}
                    >
                    {
                        item.map((_item,i)=>{
                            return <div  key={i} className="">
                                    <img onClick={()=>handleClick(_item.link)} src={_item.images} alt={_item.name} style={{width: '100%',height:126}}/>
                            </div>
                        })
                    }
                
                </Carousel>
            ):(null)
        }</div>
        
    )
}

export {Layout_1,Layout_2, Layout_3}